//** industry Api
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import showLoader from '@components/loader';
import { setLoading } from '../../../../@core/components/skelton/store';

export const getCustomField = createAsyncThunk('moduleField/getCustomField', async (_, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/custom-field', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getCustomFieldOption = createAsyncThunk('moduleField/getCustomFieldOption', async () => {
    try {
        let response = await axios.get('/custom-field/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createCustomField = createAsyncThunk('moduleField/createCustomField', async (data, { dispatch }) => {
    try {
        showLoader(true);
        let response = await axios.post('/custom-field', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        toast.success(response?.data?.message || 'Custom Field added successfully.');
        dispatch(getCustomField());
        return Promise.resolve(response);
    } catch (err) {
        showLoader(false);
        console.log('err', err);
        toast.error(err?.response?.data?.message?.msg || err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
        // return rejectWithValue(err);
    }
});

export const updateCustomField = createAsyncThunk('moduleField/updateCustomField', async (data, { dispatch }) => {
    try {
        showLoader(true);
        let response = await axios.put('/custom-field/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        toast.success(response?.data?.message || 'Custom Field updated successfully.');
        await dispatch(getCustomField());
        return Promise.resolve(response);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCustomFieldStatus = createAsyncThunk('moduleField/updateCustomFieldStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);
        let response = await axios.put('/custom-field/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        toast.success(response?.data?.message || 'Custom Field Status updated successfully !');
        dispatch(getCustomField());
        return Promise.resolve(response);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteCustomField = createAsyncThunk('moduleField/deleteCustomField', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);
        let response = await axios.delete('/custom-field/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        toast.success(response?.data?.message || 'Custom Field deleted successfully.');
        await dispatch(getCustomField());
        return Promise.resolve(response);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getFormFields = createAsyncThunk('moduleField/getFormFields', async (_, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('modules-fields/fields/0', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateModulesAndFieldsSettings = createAsyncThunk('moduleField/modules-fields', async (data, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/modules-fields', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        await dispatch(getFormFields());
        dispatch(setLoading(false));
        toast.success(response?.data?.message || 'Modules & fields saved successfully.');
        return Promise.resolve(response);
    } catch (err) {
        showLoader(false);
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const customField = createSlice({
    name: 'moduleField',
    initialState: {
        formFields: [],
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getCustomField.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getFormFields.fulfilled, (state, action) => {
            state.formFields = action.payload;
            return;
        });
        builder.addCase(getCustomFieldOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default customField.reducer;